exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-tabs-offset[data-v-35eb825d] {\n  margin-top: -15px;\n}", ""]);

// exports
